import { useFormikContext } from 'formik';
import { useCheckoutState } from '../../utils/checkoutState';
import useAdyen, { AdyenConfig, AdyenParams } from '../../utils/useAdyen';

// https://docs.adyen.com/payment-methods/blik/web-component/
const AdyenBlikPayment = ({ isSPAY }: { isSPAY?: boolean }) => {
  const { adyenSpecificationPayloadRef } = useCheckoutState();
  const { setFieldValue } = useFormikContext<{ paymentMethod: string }>();

  const adyenConfig: AdyenConfig = {
    withPspSession: isSPAY,
    onChange: ({ isValid, data, canBeRecurring }: AdyenParams & { canBeRecurring?: boolean }) => {
      const { paymentMethod, origin, browserInfo, storePaymentMethod } = data;
      adyenSpecificationPayloadRef.current = {
        paymentMethod,
        origin,
        browserInfo,
        ...(canBeRecurring && { storePaymentMethod })
      };
      setFieldValue('adyenBlik', { isValid });
    }
  };

  const AdyenBlikComponent = useAdyen({ name: 'blik', adyenConfig, withActions: true, withRecurring: true });
  return AdyenBlikComponent;
};

export default AdyenBlikPayment;
